import React from 'react';
import {connect} from 'react-redux';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import _ from 'lodash';
import DynamicComponentActions from 'go/actions/dynamicComponent';
import ApiActions from 'go/actions/api';
import Main from 'app-ui-componentlibrary/dist/go/components/layout/main';
import {Link} from 'react-router-dom';
import {ContentDispatch} from 'framework';
import {Container, Header, Icon, Segment, Button, Loader} from 'semantic-ui-react';
import REST from 'go/requests/rest';
import {getTimestampNowISO, checkWithinApplicationDeadline} from 'common/utils';
import Error from 'app-ui-componentlibrary/dist/go/components/common/error';
import {START_APP_PAGE} from 'app-ui-componentlibrary/dist/go/components/common/pageTitles';
import {getInfo} from 'common/storeUtils';
import goStore from 'go/store';
import {forceJsonResponse, MONO, FLUX} from 'common/utils';

export const transformPayload = (payload) => {
  let result = Object.assign({}, payload);
  return result;
};

export class ApplicationInitialize extends React.Component {
  constructor(props) {
    super(props);
    const fundingOpportunityId = _.get(
      props,
      ['match', 'params', 'fundingOpportunityId'],
      ''
    );
    this.state = {
      entityId: fundingOpportunityId,
      loading: true,
      submitting: false,
    };
  }

  componentDidMount() {
    document.title = START_APP_PAGE;
    const entityType = 'fo';
    const entityId = this.state.entityId;
    const configType = 'entityEdit';
    const configId = 'applicationInitiation';
    const {getConfig, token, postDynamicData} = this.props;

    getConfig(token, entityType, entityId, configType, configId)
      .then((res) => {
        this.setState({
          config: res.payload,
          loading: true,
        });
        if (res) {
          let data = null;
          let config = res.payload;
          data = transformPayload(data);
          this.props.init(config, data, {
            apiCall: postDynamicData,
          });
        }
      })
      .then(() => {
        const {token, saveEntitySessionData, selectedOrganizationId} = this.props;
        const {entityId} = this.state;
        if (selectedOrganizationId) {
          this.getNumberApplicationsPerOrganization(
            parseInt(entityId, 10),
            selectedOrganizationId
          );
        }
        return REST.fundingOpportunity
          .getFundingOpportunity(token, entityId)
          .then((res) => forceJsonResponse(res, MONO))
          .then((foData) => {
            this.setState({
              foData,
              loading: false,
            });
            saveEntitySessionData('fundingOpportunityData', foData);
          })
          .catch((error) => console.log(error));
      })
      .catch((error) => {
        console.error('error');
      });
  }

  componentDidUpdate(prevProps) {
    const {selectedOrganizationId} = this.props;
    const {entityId} = this.state;

    if (selectedOrganizationId !== prevProps.dynamicComponent.selectedOrganizationId) {
      this.getNumberApplicationsPerOrganization(
        parseInt(entityId, 10),
        selectedOrganizationId
      );
    }
  }

  handleSubmit = () => {
    this.setState({
      submitting: true,
    });
    this.createApplicationEntity();
  };

  getNumberApplicationsPerOrganization = (foId, selectedOrganizationId) => {
    const {token, saveEntitySessionData} = this.props;
    this.props
      .getDataByOrgIdByEntityType(token, selectedOrganizationId, 'application')
      .then((res) => {
        let numOfAppsPerOrgId = [];
        numOfAppsPerOrgId = res.payload[0]
          ? res.payload.filter((item) => item.fundingOpportunityId === foId)
          : [];
        saveEntitySessionData('appNumberForOrgId', numOfAppsPerOrgId.length);
      })
      .catch((error) => {
        console.error('error');
      });
  };

  createApplicationEntity = () => {
    const {token, dynamicComponent, loginName} = this.props;
    const {fundingOpportunityData, selectedOrganizationId} = dynamicComponent;
    const organizations = _.get(dynamicComponent, 'context.filteredOrganizations');
    const selectedOrg = _.find(organizations, [
      'organizationId',
      parseInt(selectedOrganizationId, 10),
    ]);
    const orgWithDetails = _.chain(dynamicComponent.context.organizations)
      .filter((org) =>
        _.isEqual(parseInt(selectedOrganizationId, 10), org.organizationId)
      )
      .head()
      .value();
    const orgInfo = {
      mailingState: _.get(orgWithDetails, 'mailingAddress.state'),
      physicalState: _.get(orgWithDetails, 'physicalAddress.state'),
    };
    const orgName = _.get(orgWithDetails, 'displayName', null);
    let currentDate = getTimestampNowISO();

    let additionalPayloadConfig = _.get(this.state, 'config.payload.additionalPayload');
    let additionalPayload = {};
    _.each(additionalPayloadConfig, (value, key) => {
      additionalPayload[key] = _.get(this.state, value, value);
    });

    // TODO, merge this if and the else if below. This was done for HMA,
    // and it should have refactored the prep else if to also be configurable
    if (_.get(this.state, 'config.payload.customPayload') !== undefined) {
      const customPayload = _.get(this.state, 'config.payload.customPayload');
      const keys = Object.keys(customPayload);
      let payloadToSend = {
        fundingOpportunityId: parseInt(this.state.entityId, 10),
        status: 'pendingSubmission',
        statusDate: currentDate,
        statusTimestamp: currentDate,
        organizationInfo: orgInfo,
        payload: {
          initiatorLoginName: loginName,
          initiatedTimestamp: currentDate,
          orgName: orgName,
          ...additionalPayload,
        },
      };
      _.each(keys, (key) => {
        _.set(
          payloadToSend,
          key,
          _.get(this.props, customPayload[key], customPayload[key])
        );
      });
      REST.dynamicData
        .createApplicationEntity(token, payloadToSend)
        .then(REST.handler.handleResponse)
        .then((resJson) => {
          if (resJson) {
            this.props.history.push('/application/' + resJson.entityId);
          }
        })
        .catch((error) => {
          console.error('error');
        });
    } else if (!_.isEmpty(selectedOrg) && !_.isEmpty(fundingOpportunityData)) {
      let payloadToSend;
      payloadToSend = {
        fundingOpportunityId: _.toInteger(
          _.get(fundingOpportunityData, 'fundingOpportunityId')
        ),
        organizationId: _.toInteger(selectedOrg.organizationId),
        organizationInfo: orgInfo,
        payload: {
          initiatorLoginName: loginName,
          initiatedTimestamp: currentDate,
          orgName: orgName,
          ...additionalPayload,
        },
      };

      // TODO This will change when new API that will create grant Id is ready - GMM-6483
      REST.dynamicData
        .createGrant(token, payloadToSend)
        .then(REST.handler.handleResponse)
        .then((resJson) => {
          if (resJson) {
            this.props.history.push(
              '/application/' + _.get(resJson, 'grant-application') + '/edit'
            );
          }
        })
        .catch((error) => {
          console.error('error');
        });
    }
  };

  render() {
    const {config, dynamicComponent} = this.props;
    const {foData, loading, submitting} = this.state;
    const {context, data} = dynamicComponent;
    return (
      <React.Fragment>
        {loading && <Loader active />}
        {!loading && checkWithinApplicationDeadline(foData) && (
          <Main>
            <Container id="appInitContainer">
              <Header as="h2">Start an application</Header>
              <Segment>
                <div ref={this.handleContextRef}>
                  {_.get(config, 'payload') ? (
                    <ContentDispatch
                      className="contentDispatch"
                      config={config.payload}
                      data={data}
                      context={context}
                      dynamicComponent={dynamicComponent}
                      handleSubmit={this.handleSubmit}
                    />
                  ) : (
                    <Loader active inline="centered" />
                  )}
                </div>
                <br />
                <Button
                  color={'blue'}
                  id={'id'}
                  className={false ? 'errorFieldBorder' : ''}
                  value={'value'}
                  type={'type'}
                  onClick={this.handleSubmit}
                  disabled={
                    _.get(dynamicComponent, ['validationErrors', 'allValid'], false) ===
                      false || submitting
                  }
                  width={'medium'}
                >
                  {'Start your application'}
                </Button>
                <br />
                <br />
                <Link to="/">
                  <Icon name="cancel" />
                  Cancel
                </Link>
                <br />
                <br />
              </Segment>
              <br />
            </Container>
          </Main>
        )}
        {!loading && !checkWithinApplicationDeadline(foData) && <Error />}
      </React.Fragment>
    );
  }
}

export const mapStateToProps = (state) => {
  const {config, sessionData} = state.dynamicComponent;
  return {
    data: state.dynamicComponent.data,
    config,
    sessionData,
    context: state.dynamicComponent.context,
    dynamicComponent: state.dynamicComponent,
    selectedOrganizationId: state.dynamicComponent.selectedOrganizationId,
    token: state.auth.token,
    permissions: state.auth.permissions,
    loginName: state.auth.loginName,
  };
};
export const mapDispatchToProps = (dispatch) => ({
  init: (config, data, serviceCall) =>
    dispatch(DynamicComponentActions.init(config, data, serviceCall)),

  getConfig: (token, entityType, entityId, configType, configId) => {
    let action = ApiActions.config.getConfig(
      token,
      entityType,
      entityId,
      configType,
      configId
    );
    const res = dispatch(action);
    return res;
  },
  postDynamicData: (payload, token) => {
    const data = payload.data ? payload.data : payload;
    const dataPayload = JSON.stringify(_.omit(data, ['version']));
    let action = ApiActions.dynamicData.postData(token, dataPayload);
    const res = dispatch(action);
    return res;
  },
  getDataByOrgIdByEntityType: (token, orgId, entityType) => {
    const action = ApiActions.dynamicData.getDataByOrgIdByEntityType(
      token,
      orgId,
      entityType
    );
    const response = dispatch(action);
    return response;
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(connectDynamic(ApplicationInitialize));
